import {themeMenuModeLSKey} from '../../../partials'
import {EventHandlerUtil} from '../_utils'

type Mode = 'light'

class ThemeMode {
  menu: HTMLElement | null = null
  element: HTMLElement | null = null

  public getMode = (): Mode => {
    return 'light'
  }

  public setMode = (_mode: Mode, _menuMode: Mode | ''): void => {
    // Read active menu item
    const activeMenuItem: HTMLElement | null =
      this.menu?.querySelector('[data-kt-element="mode"][data-kt-value="light"]') || null

    // Enable switching state
    this.element?.setAttribute('data-kt-theme-mode-switching', 'true')

    // Set mode to the target element
    this.element?.setAttribute('data-bs-theme', 'light')

    // Disable switching state after delay
    setTimeout(() => {
      this.element?.removeAttribute('data-kt-theme-mode-switching')
    }, 300)

    // Set active menu item
    if (activeMenuItem) {
      this.setActiveMenuItem(activeMenuItem)
    }

    // Flip images to light
    this.flipImages()
  }

  public getMenuMode = (): Mode | '' => {
    return 'light'
  }

  public getSystemMode = (): Mode => {
    return 'light'
  }

  private initMode = (): void => {
    this.setMode('light', 'light')
    if (this.element) {
      EventHandlerUtil.trigger(this.element, 'kt.thememode.init')
    }
  }

  private getActiveMenuItem = (): HTMLElement | null => {
    return this.menu?.querySelector('[data-kt-element="mode"][data-kt-value="light"]') || null
  }

  private setActiveMenuItem = (item: HTMLElement): void => {
    const activeItem = this.menu?.querySelector('.active[data-kt-element="mode"]')
    if (activeItem) {
      activeItem.classList.remove('active')
    }

    item.classList.add('active')
    localStorage.setItem(themeMenuModeLSKey, 'light')
  }

  private handleMenu = (): void => {
    this.menu
      ?.querySelectorAll<HTMLElement>('[data-kt-element="mode"]')
      ?.forEach((item: HTMLElement) => {
        item.addEventListener('click', (e) => {
          e.preventDefault()
          this.setMode('light', 'light')
        })
      })
  }

  public flipImages = (): void => {
    document.querySelectorAll<HTMLElement>('[data-kt-img-dark]')?.forEach((item: HTMLElement) => {
      if (item.tagName === 'IMG') {
        if (item.hasAttribute('data-kt-img-light')) {
          item.setAttribute('src', item.getAttribute('data-kt-img-light') || '')
        }
      } else {
        if (item.hasAttribute('data-kt-img-light')) {
          item.style.backgroundImage = "url('" + item.getAttribute('data-kt-img-light') + "')"
        }
      }
    })
  }

  public on = (name: string, handler: Function) => {
    if (this.element) {
      return EventHandlerUtil.on(this.element, name, handler)
    }
  }

  public off = (name: string, handlerId: string) => {
    if (this.element) {
      return EventHandlerUtil.off(this.element, name, handlerId)
    }
  }

  public init = () => {
    this.menu = document.querySelector<HTMLElement>('[data-kt-element="theme-mode-menu"]')
    this.element = document.documentElement

    this.initMode()

    if (this.menu) {
      this.handleMenu()
    }
  }
}

const ThemeModeComponent = new ThemeMode()
export {ThemeModeComponent}
